import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCountries = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.4209 13.6252C2.86834 7.59052 7.90626 2.8335 14.0552 2.8335C13.0859 2.8335 12.2228 3.25841 11.5128 3.90814C10.8064 4.55462 10.2094 5.45707 9.72656 6.52384C9.24086 7.5969 8.86358 8.85196 8.60823 10.214C8.40353 11.3058 8.27896 12.4568 8.23744 13.6252H2.4209ZM2.4209 15.3752H8.23744C8.27896 16.5436 8.40353 17.6946 8.60823 18.7864C8.86358 20.1484 9.24086 21.4034 9.72656 22.4765C10.2094 23.5433 10.8064 24.4457 11.5128 25.0922C12.2228 25.7419 13.0859 26.1668 14.0552 26.1668C7.90626 26.1668 2.86834 21.4098 2.4209 15.3752Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0552 4.4614C13.7344 4.4614 13.3199 4.59792 12.8379 5.03898C12.3524 5.4833 11.8664 6.17967 11.4369 7.12843C11.0103 8.0709 10.6639 9.20864 10.4256 10.4801C10.2378 11.4813 10.1214 12.5427 10.0805 13.6252H18.03C17.9891 12.5427 17.8727 11.4813 17.6849 10.4801C17.4466 9.20864 17.1002 8.0709 16.6736 7.12843C16.2441 6.17967 15.7581 5.4833 15.2725 5.03898C14.7906 4.59792 14.3761 4.4614 14.0552 4.4614Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4256 18.5203C10.6639 19.7917 11.0103 20.9294 11.4369 21.8719C11.8664 22.8207 12.3524 23.517 12.8379 23.9613C13.3199 24.4024 13.7344 24.5389 14.0552 24.5389C14.3761 24.5389 14.7906 24.4024 15.2725 23.9613C15.7581 23.517 16.2441 22.8207 16.6736 21.8719C17.1002 20.9294 17.4466 19.7917 17.6849 18.5203C17.8727 17.519 17.9891 16.4576 18.03 15.3752H10.0805C10.1214 16.4576 10.2378 17.519 10.4256 18.5203Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0552 2.8335C15.0246 2.8335 15.8876 3.25841 16.5976 3.90815C17.3041 4.55463 17.9011 5.45707 18.3839 6.52384C18.8696 7.59691 19.2469 8.85196 19.5023 10.214C19.707 11.3058 19.8315 12.4568 19.8731 13.6252H25.6896C25.2421 7.59052 20.2042 2.8335 14.0552 2.8335Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5023 18.7864C19.2469 20.1484 18.8696 21.4034 18.3839 22.4765C17.9011 23.5433 17.3041 24.4457 16.5976 25.0922C15.8876 25.7419 15.0246 26.1668 14.0552 26.1668C20.2042 26.1668 25.2421 21.4098 25.6896 15.3752H19.8731C19.8315 16.5436 19.707 17.6946 19.5023 18.7864Z",
			fill: "#808080"
		})
	]
});
const ForwardRef = forwardRef(SvgCountries);
export default ForwardRef;
